// Generated by ReScript, PLEASE EDIT WITH CARE


var errorCmpTitle = "Something happened from our side";

var reloadBtnText = "Click Here to Reload";

export {
  errorCmpTitle ,
  reloadBtnText ,
  
}
/* No side effect */
